<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-12">
        <div class="card border-right">
          <div class="card-body p-4">
            <h4 class="card-title">
              Обновить профиль
              <button
                class="btn btn-danger btn-sm float-right"
                @click.prevent="logout"
                v-b-tooltip.hover
                title="Выход"
              >
                <fai icon="power-off"></fai>
                <span class="d-none d-sm-inline">
                  Выход
                </span>
              </button>
              <button
                class="btn btn-info btn-sm float-right mr-2"
                @click="$bvModal.show('bv-modal-changePass')"
                v-b-tooltip.hover
                title="Изменить пароль"
              >
                <fai icon="key"></fai>
                <span class="d-none d-sm-inline">
                  Изменить пароль
                </span>
              </button>
              <b-modal id="bv-modal-changePass" hide-footer>
                <template v-slot:modal-title>
                  Изменить пароль
                </template>
                <div class="d-block">
                  <form
                    @submit.prevent="changePassword"
                    @keydown="passwordForm.errors.clear($event.target.name)"
                  >
                    <div class="row">
                      <div class="col-12 col-sm-12">
                        <div class="form-group">
                          <label for="">
                            Текущий пароль
                          </label>
                          <input
                            class="form-control"
                            type="password"
                            value=""
                            v-model="passwordForm.current_password"
                            name="current_password"
                            placeholder="Текущий пароль"
                          />
                          <show-error
                            :form-name="passwordForm"
                            prop-name="current_password"
                          ></show-error>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12">
                        <div class="form-group">
                          <label for="">Новый пароль</label>
                          <div v-if="getConfig('password_strength_meter')">
                            <password
                              v-model="passwordForm.new_password"
                              name="new_password"
                              defaultClass="form-control"
                              placeholder="Новый пароль"
                              :required="false"
                            ></password>
                          </div>
                          <div v-else>
                            <input
                              type="password"
                              name="new_password"
                              class="form-control"
                              placeholder="Новый пароль"
                              v-model="passwordForm.new_password"
                            />
                          </div>
                          <show-error
                            :form-name="passwordForm"
                            prop-name="new_password"
                          ></show-error>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12">
                        <div class="form-group">
                          <label for="">
                            Подтвердите пароль
                          </label>
                          <input
                            class="form-control"
                            type="password"
                            value=""
                            v-model="passwordForm.new_password_confirmation"
                            name="new_password_confirmation"
                            placeholder="Подтвердите пароль"
                          />
                          <show-error
                            :form-name="passwordForm"
                            prop-name="new_password_confirmation"
                          ></show-error>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-info waves-effect waves-light pull-right"
                    >
                      Изменить пароль
                    </button>
                  </form>
                </div>
              </b-modal>
            </h4>
            <hr />
            <form
              @submit.prevent="updateProfile"
              @keydown="profileForm.errors.clear($event.target.name)"
            >
            <div style="display:flex; flex-direction:row; width:100%; align-items:center">
              <div class="row" style="width:50%; align-items:flex-end">
                <div class="col-12 col-sm-3">
                  <div class="form-group d-flex">
                    <label>Аватар</label>
                    <!--upload-image
                      id="avatar"
                      :upload-path="`/user/profile/avatar/${getAuthUser('id')}`"
                      :remove-path="
                        `/user/profile/avatar/remove/${getAuthUser('id')}`
                      "
                      :image-source="getAvatarUrl(avatar.user)"
                      @uploaded="updateAvatar"
                      @removed="updateAvatar"
                    ></upload-image-->
                    <AvatarSelect @upload="selectAvatar" :img="avatar.user" @remove="removeAvatar" />
                  </div>
                </div>
              </div>
              <div class="row" style="padding-left:55px">
                <div class="col-12 col-sm-3">
                  <div class="form-group">
                    <label for="">Фамилия</label>
                    <input
                      class="form-control"
                      type="text"
                      name="last_name"
                      v-model="profileForm.last_name"
                    />
                    <show-error
                      :form-name="profileForm"
                      prop-name="last_name"
                    ></show-error>
                  </div>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="form-group">
                    <label for="">Имя</label>
                    <input
                      class="form-control"
                      type="text"
                      name="first_name"
                      v-model="profileForm.first_name"
                    />
                    <show-error
                      :form-name="profileForm"
                      prop-name="first_name"
                    ></show-error>
                  </div>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="form-group">
                    <label>Отчество</label>
                    <input class="form-control" type="text" name="middle_name"
                      v-model="profileForm.middle_name"/>
                    <show-error
                      :form-name="profileForm"
                      prop-name="middle_name"
                    ></show-error>
                  </div>
                </div>
              </div>
              </div>
              <button
                type="submit"
                class="btn btn-info waves-effect waves-light pull-right"
              >
                Сохранить
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadImage from '../components/upload-image';
import password from 'vue-password-strength-meter';
import helper from '@app/services/helper';
import AvatarSelect from '@app/components/uikit/AvatarSelect';
import { uploadImageApi } from '@app/services';

export default {
  components: {
   // uploadImage,
    password,
    AvatarSelect
  },
  data() {
    return {
      profileForm: new Form(
        {
          first_name: '',
          middle_name: '',
          last_name: ''
        },
        false
      ),
      systemConfigVariables: {
        color_themes: [],
        locales: []
      },
      passwordForm: new Form({
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      }),
      avatar: {
        user: ''
      },
      configForm: new Form(
        {
          color_theme: '',
          locale: ''
        },
        false
      )
    };
  },
  computed: {
    avatar1() {
      return this.$store.state.permission.avatar;
    }
  },
  mounted() {
    let pageLoader = Vue.$loading.show();
    const user = this.$store.state.auth.user;
    axios
      .get('/api/user/'+user.id)
      .then(response => response.data)
      .then(user => {
        this.user = user;
        this.profileForm.first_name = user.profile.first_name;
        this.profileForm.middle_name = user.profile.middle_name;
        this.profileForm.last_name = user.profile.last_name;
        const url = user.profile.avatar;
   /*   process.env.NODE_ENV === 'production'
        ? '/' + user.profile.avatar
        : '/' + user.profile.avatar
        ? process.env.VUE_APP_API_URL + '/' + user.profile.avatar
        : '/' + user.profile.avatar; */
        this.avatar.user = user.profile.avatar ? url : null; // user.profile.avatar;
        pageLoader.hide();
      })
      .catch(error => {
        helper.showDataErrorMsg(error);
      });

  },
  methods: {
    async selectAvatar(file) { console.log(file);
      const avatar = await this.uploadFile(file);
      this.avatar.user = avatar;
      this.updateAvatar(file);
      await this.$store.dispatch('clinic/saveAvatar', avatar);
      await this.$store.dispatch('permission/loadPermissions');
    },
    async removeAvatar() {
      this.avatar.user = null;
      this.updateAvatar(null);
      await this.$store.dispatch('clinic/saveAvatar', null);
      await this.$store.dispatch('permission/loadPermissions');

    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      return await uploadImageApi.upload(formData);
    },
    async updateProfile() {
      let pageLoader = Vue.$loading.show();
      const user = this.$store.state.auth.user; console.log(this.profileForm);
      await this.$store.dispatch('clinic/savePersonal', { firstName: this.profileForm.first_name, lastName: this.profileForm.last_name, middleName: this.profileForm.middle_name});
      await this.$store.dispatch('permission/loadPermissions');
      this.$store.dispatch('auth/setAuthUserDetail', {
            first_name: this.profileForm.first_name,
            last_name: this.profileForm.last_name
          });
          pageLoader.hide();
     // await this.$store.dispatch('permission/loadPermissions');
    /*  axios
        .put('/api/user/'+user.id, {
            first_name: this.profileForm.first_name,
            middle_name: this.profileForm.middle_name,
            last_name: this.profileForm.last_name
        })
        .then(response => { console.log(response);
          toastr.success(response.message ? response.message : 'Успешно сохранено!');
          this.$store.dispatch('auth/setAuthUserDetail', {
            first_name: this.profileForm.first_name,
            last_name: this.profileForm.last_name
          });
          pageLoader.hide();
        })
        .catch(error => {
          helper.showErrorMsg(error);
        });*/
    },
    getConfig(config) {
      return helper.getConfig(config);
    },
    changePassword() {
      this.passwordForm
        .post('/api/change-password')
        .then(response => {
          toastr.success(response.message);
          this.$bvModal.hide('bv-modal-changePass');
        })
        .catch(error => {
          helper.showErrorMsg(error);
        });
    },
    updateAvatar(val) {
      let pageLoader = Vue.$loading.show();
      this.$store.dispatch('auth/setAuthUserDetail', {
        avatar: val
      });
      pageLoader.hide();
    },
    logout() {
      helper.logout().then(() => {
        this.$store.dispatch('auth/resetAuthUserDetail');
        this.$router.push('/');
      });
    },
    getAuthUser(name) {
      return helper.getAuthUser(name);
    },
    updatePreference() {
      this.preferenceForm
        .post('/api/user/preference')
        .then(response => {
          toastr.success(response.message);

          $('#theme').attr(
            'href',
            '/css/colors/' + this.preferenceForm.color_theme + '.css'
          );

          if (
            this.user_preference.direction != this.preferenceForm.direction ||
            this.user_preference.sidebar != this.preferenceForm.sidebar ||
            this.user_preference.locale != this.preferenceForm.locale
          )
            location.reload();
        })
        .catch(error => {
          helper.showErrorMsg(error);
        });
    },
    getAvatarUrl(avatar) {
      return helper.getImageUrl(avatar);
    }
  }
};
</script>

<style lang="scss" scoped>
.row {
  margin: 0 !important;
  flex-direction: column;
  width: 100%;
}
.col {
  padding: 0 !important;
}
.form-control {
  border-radius: 25px;
  padding: 0 15px 0 15px;
}
.d-flex {
  flex-direction: column;
  align-items: center;
}
</style>
